import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import NewHeader from '../public/NewHeader';
import SiteFooter from '../public/SiteFooter';
import CartModal from '../../components/common/CartModal';
import { useCartWishlist } from '../../context/CartWishlistContext';
import './UserLayout.css';

const UserLayout = () => {
  const navigate = useNavigate();
  const [cartModalOpen, setCartModalOpen] = useState(false);
  const { cartItems, cartTotal, removeFromCart, updateCartItem } = useCartWishlist();

  const handleCartCheckout = () => {
    setCartModalOpen(false);
    navigate('/user/cart');
  };

  return (
    <div className="user-layout">
      <NewHeader onCartClick={() => setCartModalOpen(true)} />
      <main className="user-layout__content">
        <Outlet />
      </main>
      <SiteFooter />

      <CartModal
        isOpen={cartModalOpen}
        onClose={() => setCartModalOpen(false)}
        cartItems={cartItems}
        cartTotal={cartTotal}
        onRemoveItem={removeFromCart}
        onUpdateQuantity={updateCartItem}
        onCheckout={handleCartCheckout}
      />
    </div>
  );
};

export default UserLayout;
